/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function isFunction(x) {
    return typeof x === 'function';
}
//# sourceMappingURL=isFunction.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/isFunction.js
// module id = 182
// module chunks = 2